module.exports = __webpack_public_path__ + "images/error-visual-0c468d7a.svg";